import { AdjustmentTypeService } from '../../../revenue/shared/adjustment-types/adjustment-type.service';
import { InvoiceUpsertDto } from '../../dto/invoice-upsert.dto';
import { Component, OnInit, Input } from '@angular/core';
import { AdjustmentType } from 'src/app/revenue/shared/adjustment-types/adjustment-type.model';
import { RevenueItem } from 'src/app/revenue/shared/revenue-items/revenue-item.model';

@Component({
  selector: 'wl-invoice-adjustments-list',
  templateUrl: './invoice-adjustments-list.component.html',
  styleUrls: ['./invoice-adjustments-list.component.less'],
    standalone: false
})
export class InvoiceAdjustmentsListComponent implements OnInit {
  @Input() invoice: InvoiceUpsertDto;
  @Input() flatAdjustmentIds: Array<number>;
  @Input() isLineItemAdjustments: boolean;
  @Input() allRevenueItems: RevenueItem[];

  public adjustmentTypes: Array<AdjustmentType>;

  constructor(private _adjustmentTypeService: AdjustmentTypeService) {}

  ngOnInit() {
    if (!this.adjustmentTypes) {
      this._adjustmentTypeService.getAdjustmentTypes().then((data: Array<AdjustmentType>) => {
        this.adjustmentTypes = data;
      });
    }
  }
}
